import React, { useState, useMemo } from "react";
import Card from "../card";
import MainImage from "../image";
import {
  A_P_TEMPLES,
  RESOURCES,
  TEMPLATE_INFO,
} from "../../utilities/constants";
import MainRadioButton from "../radioButton";
import MainDropDown from "../dropDown/MainDropDown";

import "../wizardPage/index.scss";

const APList = ({
  itemList,
  onClick,
  id,
  selectedTemplate,
  setSelectedTemplate,
  templateData,
}) => {
  const [showInfoPopUp, setShowInfoPopUp] = useState(null);
  const [customTemplate, setCustomTemplate] = useState(null);

  const popUpData = useMemo(() => {
    const data = selectedTemplate ? { ...selectedTemplate } : {};

    if (typeof data?.data?.resources == "string") {
      data.data.resources = JSON.parse(data.data.resources);
    }

    return data;
  }, [selectedTemplate]);

  const handleSelect = (data) => {
    setSelectedTemplate(data);
  };

  return (
    <>
      <section className={"ap-item-list-container wizard-container"}>
        {itemList.map((item) => {
          if (!templateData[item.type]) {
            return null;
          }
          return (
            <Card
              key={item.id}
              onClick={(e) => {
                if (id !== item.id) {
                  onClick(item);
                  setSelectedTemplate("null");
                  setSelectedTemplate(templateData[item.type]?.checkBox[0]);
                  setCustomTemplate(null);
                  setShowInfoPopUp(null);
                }
              }}
              title={item.name}
              className={`${id === item.id ? "" : "disabled"}  wizard-item`}
            >
              <section
                className="wizard-item-img-container"
                onClick={() => {
                  if (id === item.id) {
                    setShowInfoPopUp(showInfoPopUp ? null : item.id);
                  }
                }}
              >
                <MainImage src={item.img} alt="Test img" />
              </section>
              <section className="wizard-item-radio wizard-item-img-container ">
                {templateData[item.type]?.checkBox.map((element) => {
                  return (
                    <MainRadioButton
                      className={`${
                        element.value === selectedTemplate.value
                          ? "selected"
                          : ""
                      }`}
                      key={element.value}
                      checked={element.value === selectedTemplate.value}
                      label={element.label}
                      onClick={(e) => {
                        if (id === item.id) {
                          setSelectedTemplate(element);
                          setCustomTemplate(null);
                        }
                      }}
                    />
                  );
                })}
                <MainRadioButton
                  className={`custom_template_${
                    item.type
                  } === customTemplate ? "selected" : "" `}
                  checked={`custom_template_${item.type}` === customTemplate}
                  label={"Use Template"}
                  onClick={() => {
                    if (id === item.id) {
                      setSelectedTemplate(`custom_template_${item.type}`);
                      setCustomTemplate(`custom_template_${item.type}`);
                    }
                  }}
                />
              </section>
              <section className={`wizard-item-dropdown ${templateData[item.type]?.checkBox.length < 2 ? "margin-top" : "" } `}>
                <span className={"description"}>Select a Template</span>
                <MainDropDown
                  selectedOption={`${selectedTemplate.value}`}
                  disabled={
                    `custom_template_${item.type}` !== customTemplate ||
                    !templateData[item.type]?.options.length
                  }
                  options={templateData[item.type]?.options || []}
                  placeholder="Choose an option"
                  onSelect={handleSelect}
                />
              </section>
              {item.id === showInfoPopUp && popUpData.data && (
                <div className="hover-popup">
                  <p className="description">
                    This access point will include the following configuration
                  </p>
                  <div>
                    {popUpData.data.readers
                      ? popUpData.data.readers.map((item, index) => {
                          return (
                            <div key={index}>
                              <h6 className="title">Reader- {index + 1}</h6>
                              <h6 className="description">
                                Port- {TEMPLATE_INFO["reader"][item.port].label}
                              </h6>
                              <h6 className="description">
                                Direction-{" "}
                                {
                                  TEMPLATE_INFO["reader"]["direction"][
                                    item.direction
                                  ]
                                }{" "}
                              </h6>
                            </div>
                          );
                        })
                      : null}
                  </div>
                  <div>
                    {popUpData.data.resources
                      ? Object.keys(popUpData.data.resources).map(
                          (item, index) => {
                            return (
                              <div key={item}>
                                <h6 className="title">
                                  {RESOURCES[item].label} {index + 1}
                                </h6>
                                {popUpData.data.resources[item].input ? (
                                  <>
                                    <h6 className="description">
                                      {" "}
                                      Connection Pin-{" "}
                                      {popUpData.data.resources[item]
                                        .component_source == "0"
                                        ? TEMPLATE_INFO["input"]["0"][
                                            popUpData.data.resources[item].input
                                          ]?.label || "CUSTOM"
                                        : popUpData.data.resources[item].input}
                                    </h6>
                                  </>
                                ) : (
                                  <>
                                    <h6 className="description">
                                      {" "}
                                      Connection output-{" "}
                                      {popUpData.data.resources[item]
                                        .component_source == "0"
                                        ? TEMPLATE_INFO["output"]["0"][
                                            popUpData.data.resources[item]
                                              .output
                                          ]?.label || "CUSTOM"
                                        : popUpData.data.resources[item].output}
                                    </h6>
                                    <h6 className="description">
                                      {" "}
                                      Lock type-{" "}
                                      {
                                        TEMPLATE_INFO["output"]["relay_mode"][
                                          popUpData.data?.resources[item]
                                            ?.relay_mode
                                        ].label
                                      }
                                    </h6>

                                    <h6 className="description">
                                      {" "}
                                      Duration of hold-{" "}
                                      {
                                        popUpData.data.resources[item]
                                          .entry_exit_open_durations
                                      }{" "}
                                      seconds
                                    </h6>
                                  </>
                                )}
                              </div>
                            );
                          }
                        )
                      : null}
                  </div>
                </div>
              )}
            </Card>
          );
        })}
      </section>
    </>
  );
};

export default APList;
